import {
  Button,
  Icon,
  Label,
  Loader,
  Modal,
  Segment,
  Table,
} from "semantic-ui-react";
import axios from "axios";
import { BASE_API, STORAGE_KEYS } from "../../../../../utils/constantes";
import { useEffect, useState } from "react";

const DetalleBeneficiarioMista = ({ beneficiario = "" }) => {
  const btnInicial = { color: "blue", text: "Importar" };

  const [loading, setLoading] = useState(false);
  const [importButton, setImportButton] = useState(btnInicial);
  const [modalAbierto, setModalAbierto] = useState(false);

  useEffect(() => {
    setImportButton(btnInicial);
    setModalAbierto(false);
  }, [beneficiario]);

  const formatFecha = (isoDate) => {
    if (!isoDate) return "-";
    try {
      return new Date(isoDate).toLocaleDateString("es-AR");
    } catch {
      return isoDate;
    }
  };

  const importarBeneficiario = async () => {
    try {
      setLoading(true);
      const { policies: _policies, ...payloadPlano } = beneficiario;
      const response = await axios.post(
        `${BASE_API}/api/clientes/`,
        [payloadPlano],
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(STORAGE_KEYS.TOKEN)}`,
          },
        }
      );

      setLoading(false);

      if (response.status === 200) {
        setImportButton({ color: "green", text: "Importado" });
      } else {
        setImportButton({ color: "red", text: "Error" });
      }
    } catch (error) {
      setLoading(false);
      console.error("Error al importar beneficiario:", error);
      setImportButton({ color: "red", text: "Error" });
    }
  };

  if (beneficiario) {
    const policies = beneficiario.policies || [];

    return (
      <>
        <Segment style={{ marginTop: "30px" }}>
          <h3>Resultado</h3>
          <div
            style={{ overflowX: "auto", overflowY: "auto", maxHeight: "45vh" }}
          >
            <Table celled striped>
              <Table.Header style={{ position: "sticky", top: 0, zIndex: 1 }}>
                <Table.Row>
                  <Table.HeaderCell>Nombre</Table.HeaderCell>
                  <Table.HeaderCell>Apellido</Table.HeaderCell>
                  <Table.HeaderCell>DNI</Table.HeaderCell>
                  <Table.HeaderCell>Fecha de Nacimiento</Table.HeaderCell>
                  <Table.HeaderCell>Vigencia</Table.HeaderCell>
                  <Table.HeaderCell>Vínculo</Table.HeaderCell>
                  <Table.HeaderCell>Acción</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>{beneficiario.nombre}</Table.Cell>
                  <Table.Cell>{beneficiario.apellido}</Table.Cell>
                  <Table.Cell>{beneficiario.dni}</Table.Cell>
                  <Table.Cell>{beneficiario.fecha_nacimiento}</Table.Cell>
                  <Table.Cell>{beneficiario.vigencia}</Table.Cell>
                  <Table.Cell>{beneficiario.vinculo}</Table.Cell>
                  <Table.Cell>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "6px",
                      }}
                    >
                      <Button
                        size="mini"
                        color="blue"
                        onClick={() => setModalAbierto(true)}
                        style={{ margin: 0 }}
                      >
                        Detalles
                      </Button>
                      <Button
                        size="mini"
                        color={importButton.color}
                        onClick={() => importarBeneficiario()}
                        disabled={loading}
                        style={{ margin: 0 }}
                      >
                        {loading ? (
                          <Loader active inline size="mini" />
                        ) : (
                          importButton.text
                        )}
                      </Button>
                    </div>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
        </Segment>

        <Modal
          open={modalAbierto}
          onClose={() => setModalAbierto(false)}
          size="large"
        >
          <Modal.Header>
            Detalles del beneficiario{" "}
          </Modal.Header>
          <Modal.Content scrolling>
            <Segment secondary style={{ marginBottom: "16px" }}>
              <strong>Asegurado:</strong> {beneficiario.nombre}{" "}
              {beneficiario.apellido} &mdash; DNI {beneficiario.dni}
            </Segment>

            {policies.length > 0 ? (
              policies.map((poliza) => (
                <Segment
                  key={poliza.policyCode}
                  style={{ marginBottom: "12px" }}
                >
                  <h4 style={{ marginTop: 0, marginBottom: "10px" }}>
                    Póliza {poliza.policyNumber}{" "}
                    <span style={{ fontWeight: "normal", color: "#666" }}>
                      {poliza.alias}
                    </span>
                  </h4>
                  <p style={{ marginBottom: "10px" }}>
                    <strong>Producto:</strong> {poliza.productName}
                  </p>
                  <Table
                    definition
                    compact
                    size="small"
                    style={{ marginBottom: "12px" }}
                  >
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>Vigencia</Table.Cell>
                        <Table.Cell>
                          {formatFecha(poliza.vigenciaDesde)} &mdash;{" "}
                          {formatFecha(poliza.vigenciaHasta)}
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>Subsección</Table.Cell>
                        <Table.Cell>{poliza.subsection}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                  {poliza.coverages && poliza.coverages.length > 0 && (
                    <>
                      <strong>Coberturas</strong>
                      <Table
                        celled
                        compact
                        size="small"
                        style={{ marginTop: "6px" }}
                      >
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>Cobertura</Table.HeaderCell>
                            <Table.HeaderCell>Tipo</Table.HeaderCell>
                            <Table.HeaderCell>Suma asegurada</Table.HeaderCell>
                            <Table.HeaderCell>Fecha inclusión</Table.HeaderCell>
                            <Table.HeaderCell>Fecha exclusión</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {poliza.coverages.map((cobertura, idx) => (
                            <Table.Row key={idx}>
                              <Table.Cell>{cobertura.nombre}</Table.Cell>
                              <Table.Cell>{cobertura.tipo}</Table.Cell>
                              <Table.Cell>
                                {cobertura.sumaAsegurada != null
                                  ? `$${Number(
                                      cobertura.sumaAsegurada
                                    ).toLocaleString("es-AR")}`
                                  : "-"}
                              </Table.Cell>
                              <Table.Cell>
                                {formatFecha(cobertura.inclusionDate)}
                              </Table.Cell>
                              <Table.Cell>
                                {formatFecha(cobertura.exclusionDate)}
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </>
                  )}
                </Segment>
              ))
            ) : (
              <p>Sin pólizas activas.</p>
            )}
          </Modal.Content>
          <Modal.Actions>
            <Button color="grey" onClick={() => setModalAbierto(false)}>
              <Icon name="close" /> Cerrar
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  } else if (beneficiario !== "") {
    return (
      <Segment style={{ marginTop: "30px" }}>
        <p>No se encontraron beneficiarios.</p>
      </Segment>
    );
  }

  return null;
};

export default DetalleBeneficiarioMista;
